"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const exception2alert_1 = require("@common/tsutils/exception2alert");
const DistroData_1 = __importDefault(require("../models/DistroData"));
class DistroService {
    constructor(dataUrl) {
        this.data = new DistroData_1.default();
        this.dataLoading = false;
        this.dataUrl = dataUrl;
    }
    async call() {
        await this.fetchDistroData();
    }
    async fetchDistroData() {
        this.dataLoading = true;
        try {
            const request = await fetch(this.dataUrl);
            const response = await request.json();
            this.data = new DistroData_1.default(response[0]);
            if ((0, exception2alert_1.exception2string)(response.messages) ===
                "User doesn't have permission to see this project.") {
                window.location.href = '/results/projects';
            }
        }
        catch (error) {
            if ((0, exception2alert_1.exception2string)(error) ===
                "User doesn't have permission to see this project.") {
                window.location.href = '/results/projects';
            }
        }
        this.dataLoading = false;
    }
    async fetchDistroDataCurrentCrop(url) {
        this.dataLoading = true;
        try {
            const request = await fetch(url);
            const response = await request.json();
            this.data = new DistroData_1.default(response[0]);
            if ((0, exception2alert_1.exception2string)(response.messages) ===
                "User doesn't have permission to see this project.") {
                window.location.href = '/results/projects';
            }
        }
        catch (error) {
            if ((0, exception2alert_1.exception2string)(error) ===
                "User doesn't have permission to see this project.") {
                window.location.href = '/results/projects';
            }
        }
        this.dataLoading = false;
    }
    get collectData() {
        return this.data;
    }
    get isLoading() {
        return this.dataLoading;
    }
}
exports.default = DistroService;
